module.exports = __webpack_public_path__ + "img/VIPTop.5d082162.png";